import { visionURL } from "../config/environment";
import Jsona from "jsona";
import JsonApiService from "../services/jsonapiService";

const dataFormatter = new Jsona();

const virtualClassroomsApiService = async () =>
  new JsonApiService("virtual_classrooms", {
    baseUrl: `${visionURL}/admin_console/api/content`,
    credentials: "include"
  });

export const useVirtualClassrooms = () => {
  return {
    getVirtualClassrooms: async () => {
      const service = await virtualClassroomsApiService();
      const response = await service
        .include("status_type")
        .all()
        .then(response => response.json());
      return { data: dataFormatter.deserialize(response) };
    },
    sendReactivation: async virtualClassroomId => {
      const service = await virtualClassroomsApiService();
      const response = await service
        .include("status_type")
        .createRelated(virtualClassroomId, "reactivation")
        .then(response => response.json());
      if (response.errors) {
        throw response.errors;
      } else {
        return dataFormatter.deserialize(response);
      }
    }
  };
};
